import { EmailMySearch } from '../../../../Shared/js/EmailMySearch';
import { waitFor } from '../../../../Shared/js/utils/timer';
import { generateQueryString } from '../utils/TabletsQueryString';

export default class TabletsResultsAdaptor {
    unbindAll() {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;
        searchResultsPage.off('click');
        this.bindPreviewActions();
    }

    bindSpecsGallery() {
        const searchResultsPage = wo$('#results-container');
        if (!searchResultsPage.length) return;

        searchResultsPage.on('shown.bs.popover', '[data-tablet-specs-gallery-popover]', function () {
            WhistleOut.bindTabletSpecsModal();
            WhistleOut.bindTabletGallery();
        });
    }

    bindCoverageNetworks(filterNetworksHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        wo$('#apply-network-change').on('click', function () {
            var networks = [];
            wo$('#modal-network-coverage')
                .find('[data-network-checkbox]:checked')
                .each(function () {
                    var networkId = wo$(this).data('network-checkbox');
                    networks.push(networkId);
                });

            wo$('#modal-network-coverage').modal('hide');
            filterNetworksHandler(networks);
        });
    }

    async bindCoverageMap() {
        const searchResultsPage = wo$('#results-container');
        if (!searchResultsPage.length) return;

        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var that = this;

        const mapContainer = searchResultsPage.find('[data-coverage-maps]');
        if (!mapContainer.length) {
            return;
        }

        await waitFor(() => !!WhistleOut.CoverageMap);
        if (WhistleOut.CoverageMap) {
            WhistleOut.CoverageMap.init(searchResultsPage);
        }

        var instanceId = mapContainer.data('instance-id');
        const mobileMapElement = searchResultsPage.find('#mobile-map-' + instanceId);
        const coverageMapsButton = wo$('#network-coverage-snippet');
        if (coverageMapsButton.length) {
            if (mobileMapElement.length) {
                coverageMapsButton.removeClass('hidden');
            } else {
                coverageMapsButton.addClass('hidden');
            }
            wo$('[data-goto-coverage-map]')
                .off('click')
                .click(function () {
                    var networkId = wo$(this).data('goto-coverage-map');
                    if (networkId) {
                        WhistleOut.scrollTo('[data-coverage-maps]');
                        setTimeout(function () {
                            that.selectNetworkInCoverageMap(networkId);
                        }, 500);
                    } else {
                        WhistleOut.scrollTo('[data-coverage-maps]');
                    }
                });
        }
    }

    selectNetworkInCoverageMap(networkId) {
        var mobileMapElement = wo$('[data-mobile-map]');
        if (mobileMapElement.length) {
            var element = mobileMapElement.get(0);
            var select = wo$(element).parent().parent().find('select[data-mobile-provider]');
            select.val(networkId);
            select.selectpicker('refresh');
            select.trigger('change');
        }
    }

    hideCoverageMapButton() {
        const coverageMapsButton = wo$('#coverage-maps-button');
        if (coverageMapsButton.length) {
            coverageMapsButton.addClass('hidden');
        }
    }

    bindSupplierActions(changeCarrierHandler, showModalHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        searchResultsPage.on('click', '[data-show-only-carrier]', function () {
            const carrierShortUrl = wo$(this).data('show-only-carrier');
            changeCarrierHandler(carrierShortUrl, false);
        });

        searchResultsPage.on('click', '[data-show-all-except-carrier]', function () {
            const carrierShortUrl = wo$(this).data('show-all-except-carrier');
            changeCarrierHandler(carrierShortUrl, true);
        });

        searchResultsPage.on('click', '[data-change-carriers]', function () {
            changeCarrierHandler(showModalHandler('carriers'), true);
        });

        searchResultsPage.on('click', '[data-show-all-carriers]', function () {
            changeCarrierHandler();
        });

        searchResultsPage.on('click', '[data-show-one-result-per-carrier]', function () {
            changeCarrierHandler(null, null, true);
        });

        searchResultsPage.on('click', '[data-show-multiple-results-per-carrier]', function () {
            changeCarrierHandler(null, null, false);
        });

        wo$('body').on('click', '[data-show-filter-modal]', function () {
            showModalHandler();
        });

        searchResultsPage.on('click', '[data-copy-transact-url]', function () {
            WhistleOut.copyToClipboard(wo$(this).data('copy-transact-url'));
        });
    }

    bindHideFeatureResults(hideFeaturedResultsHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        searchResultsPage.on('click', '[data-results-action=HideAllFeaturedResults]', function () {
            hideFeaturedResultsHandler();
        });
    }

    bindSaveSearch() {
        EmailMySearch.modalInit(wo$('#modal-email-my-search'));
    }

    bindDisableMaximumResultLimits(disableMaximumResultLimitsHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        searchResultsPage.on('click', '[data-results-action=DisableMaximumResultLimits]', function () {
            disableMaximumResultLimitsHandler();
        });
    }

    bindPreviewActions() {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        searchResultsPage.on('click', 'a[data-results-action = "HideAllPreviewItems"]', function () {
            searchResultsPage.find('.results-list div[data-result].bg-pink').hide();
        });
        searchResultsPage.on('click', 'a[data-results-action = "ShowPreviewItemsOnly"]', function () {
            searchResultsPage.find('.results-list div[data-result].bg-pink').show();
            searchResultsPage.find('.results-list div[data-result]:not(.bg-pink)').hide();
        });
        searchResultsPage.on('click', 'a[data-results-action = "RemovePreviewHighlighting"]', function () {
            searchResultsPage.find('.results-list div[data-result].bg-pink').removeClass('bg-pink');
        });
    }

    bindSort(changeSortHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;

        searchResultsPage.on('click', '[data-sort-expression]', function () {
            const sortExpression = wo$(this).data('sort-expression');
            let sortAscending = true;
            const isAscending = wo$(this).data('sort-ascending');
            if (isAscending === false || isAscending === 'False') sortAscending = false;
            changeSortHandler(sortExpression, sortAscending);
        });
    }

    bindCoverageErrorStrip(retrySearchHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;
        searchResultsPage.on('click', '[data-mobile-coverage-retry]', function (args) {
            args.preventDefault();
            retrySearchHandler();
        });
    }

    getCoveragePromise(criteria, coverageUrl) {
        const promise = new Promise(resolve =>
            window.setTimeout(() => {
                const queryString = generateQueryString(criteria);
                wo$.ajax({
                    url: `${coverageUrl}?${queryString}`,
                    type: 'GET',
                    success: result => {
                        if (result) {
                            console.log('coverageResult', result);
                            WhistleOut.setCoverageCookie(result.coverage);
                            if (result.allAvailableConnectionsSelected)
                                resolve({ connectionTypes: [], hasFixed: result.hasFixed });
                            else resolve({ connectionTypes: result.defaultConnectionTypes, hasFixed: result.hasFixed });
                        } else {
                            resolve({ connectionTypes: [], hasFixed: false });
                        }
                    }
                });
            })
        );
        return promise;
    }

    bindLoadMore(loadMoreResultsHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;
        searchResultsPage.on('click', '[data-load-tab]', function () {
            const tab = wo$(this).data('load-tab');
            const current = wo$(this).data('current');
            wo$(this).find('span').show();
            loadMoreResultsHandler(tab, current);
        });
    }

    appendLoadMoreResults(tab, results) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;
        const pageSize = searchResultsPage.data('page-size');
        const $results = searchResultsPage.find('div#' + tab + ' div.results-list');
        const button = searchResultsPage.find('button[data-load-tab=' + tab + ']');
        const current = button.data('current');
        const total = button.data('total');
        const loadedRecords = current + pageSize;
        $results.append(results);
        WhistleOut.applyPopover($results);
        this.bindCta($results);
        button.data('current', loadedRecords);
        button.find('span').hide();
        if (total <= loadedRecords) {
            button.hide();
        }
    }

    bindTab(changeTabHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        const that = this;
        searchResultsPage
            .find('button[data-tab-button], button[data-tab-buttongroup], button[data-popover-button]')
            .each(function () {
                const tab = wo$(this);
                const content = tab.data('tooltip-text');
                tab.popover({
                    container: 'body',
                    trigger: 'hover',
                    placement: 'top',
                    content: content,
                    html: true
                });
            });

        searchResultsPage.on('click', '[data-goto-tab]', function () {
            const tab = wo$(this).data('goto-tab');
            that.switchTabs(tab, searchResultsPage, changeTabHandler);
        });
        searchResultsPage.on('click', '[data-tab-link]', function () {
            const tab = wo$(this).data('tab-link');
            that.switchTabs(tab, searchResultsPage, changeTabHandler);
        });
        searchResultsPage.on('click', '[data-tab-linkbutton]', function () {
            const tab = wo$(this).data('tab-linkbutton');
            that.switchTabs(tab, searchResultsPage, changeTabHandler);
        });
        searchResultsPage.on('click', '[data-tab-button]', function () {
            const tab = wo$(this).data('tab-button');
            that.switchTabs(tab, searchResultsPage, changeTabHandler);
        });
    }

    bindWidenResults(widenResultsHandler) {
        const searchResultsPage = wo$('#search-results-partial');
        if (!searchResultsPage.length) return;
        const options = {};
        searchResultsPage
            .find('[data-widen-result]')
            .off('click')
            .click(function (e) {
                e.preventDefault();
                const id = wo$(this).data('widen-result');
                const removeAll = id === 'remove-all';
                if (id === 'suppliers' || removeAll) {
                    options.includeAllSuppliers = true;
                }
                if (id === 'data' || removeAll) {
                    options.reduceData = true;
                }
                if (id === 'contractLengths' || removeAll) {
                    options.includeAllContractLengths = true;
                }
                if (id === 'priceRange' || removeAll) {
                    options.increasePriceRange = true;
                }

                if (id === 'upfront' || removeAll) {
                    options.removeMaxUpfront = true;
                }
                if (id === 'priceTypes' || removeAll) {
                    options.includeAllPriceTypes = true;
                }
                if (id === 'planTypes' || removeAll) {
                    options.includeAllPlanTypes = true;
                }
                if (id === 'deals' || removeAll) {
                    options.noDealsOnly = true;
                }

                if (id === 'sort' || removeAll) {
                    options.sortBy = true;
                }
                widenResultsHandler(options);
                WhistleOut.scrollTo(0);
            });
    }

    switchTabs(tab, searchResultsPage, changeTabHandler) {
        const selectedTabLink = searchResultsPage.find('a[data-tab-link=' + tab + ']');
        searchResultsPage.find('a[data-tab-link] > i').addClass('hidden');
        selectedTabLink.find('i').removeClass('hidden');
        selectedTabLink.closest('div').find('button span.dropdownText').text(selectedTabLink.data('text'));
        selectedTabLink.closest('div').find('button span.resultCount').text(selectedTabLink.data('count'));
        selectedTabLink.closest('div').find('button span.subtext').text(selectedTabLink.data('subtext'));

        const selectedTabLinkButton = searchResultsPage.find('a[data-tab-linkbutton=' + tab + ']');
        searchResultsPage.find('a[data-tab-linkbutton] > i').addClass('hidden');
        searchResultsPage.find('a[data-tab-linkbutton]').closest('div.btn-group').find('button').removeClass('active');
        if (selectedTabLinkButton.length > 0) {
            selectedTabLinkButton.find('i').removeClass('hidden');
            const button = selectedTabLinkButton.closest('div.btn-group').find('button');
            button.find('span.dropdownText').text(selectedTabLinkButton.data('text'));
            button.find('span.resultCount').text(selectedTabLinkButton.data('count'));
            button.find('span.subtext').text(selectedTabLinkButton.data('subtext'));
            button.addClass('active');
            const content = selectedTabLinkButton.data('tooltip-text');
            const popover = button.data('bs.popover');
            popover.options.content = content;
            popover.tip().find('.popover-content').html(content);
        }
        searchResultsPage.find('button[data-tab-button]').removeClass('active');
        searchResultsPage.find('button[data-tab-button=' + tab + ']').addClass('active');
        searchResultsPage
            .find('div[data-results-container] div#' + tab)
            .addClass('active')
            .siblings()
            .removeClass('active');
        changeTabHandler(tab);
    }

    bindPlanSummary(callback) {
        wo$('table[data-plan-summary] tr[data-supplier], table[data-plan-summary] a')
            .off('click')
            .on('click', function () {
                const supplierShortUrl = wo$(this).data('supplier');
                const maxResults = wo$(this).data('max-results');
                callback(supplierShortUrl, maxResults);
                WhistleOut.scrollTo('#landing-results');
            });
    }

    bindTabletSummary(callback) {
        wo$('table[data-tablet-summary] tr[data-tablet], table[data-tablet-summary] a[data-tablet]')
            .off('click')
            .on('click', function () {
                const tabletShortUrl = wo$(this).data('tablet');
                wo$(this).find('.slick-slide').removeClass('selected');
                wo$(this)
                    .find('.slick-slide a[data-carousel-tablet = "' + tabletShortUrl + '"]')
                    .parent()
                    .addClass('selected');
                callback(tabletShortUrl);
                WhistleOut.scrollTo('#landing-results');
            });
    }

    bindTabletCarousel(currentTabletShortUrl, callback) {
        wo$('[data-carousel-tablet="' + currentTabletShortUrl + '"]')
            .parent()
            .addClass('selected');
        wo$('[data-carousel-tablet]')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                wo$(this).find('.slick-slide').removeClass('selected');
                wo$(this).parent().addClass('selected');
                const tabletShortUrl = wo$(this).data('carousel-tablet');
                callback(tabletShortUrl);
                WhistleOut.scrollTo('#landing-results');
            });
    }

    bindLandingPageCriteria(attribute, callback) {
        const landingPage = wo$('.layout-landing');
        if (!landingPage.length) {
            return;
        }
        landingPage
            .find('[data-' + attribute + ']')
            .off('click')
            .on('click', function (e) {
                e.preventDefault();
                const value = wo$(this).data(attribute);
                callback(value);
                WhistleOut.scrollTo('#results-container');
            });
    }

    bindCriteriaFilters(criteria, callback) {
        var trueOrNull = WhistleOut.trueOrNull;
        var falseOrNull = WhistleOut.falseOrNull;

        const mappings = {
            data: (e, val) => {
                e.minimumData = parseInt(val);
            },
            fullspeeddata: (e, val) => {
                e.compareUnthrottledData = falseOrNull(val);
            },
            maxprepaidexpiry: (e, val) => {
                e.maximumPrepaidExpiryDays = parseInt(val);
            },
            maxupfront: (e, val) => {
                e.maximumTabletUpfrontCost = parseInt(val);
            },
            network: (e, val) => {
                e.networkIds = (val || '').split(',');
            },
            prepaidexpiry: (e, val) => {
                e.prepaidExpiryDays = parseInt(val);
            },
            simonly: (e, val) => {
                e.includeSimOnly = trueOrNull(val);

                if (e.includeSimOnly) {
                    e.tabletShortUrl = null;
                }
            },
            tablet: (e, val) => {
                e.tabletShortUrl = !e.includeSimOnly ? val : null;
            },
            tabletprice: (e, val) => {
                e.tabletPriceTypes = (val || '').split(',');
            },
            type: (e, val) => {
                e.planTypes = (val || '').split(',');
            }
        };

        WhistleOut.bindCriteriaFilters(
            wo$('body'),
            (el, c) => {
                WhistleOut.scrollTo('#results-container');
                callback(c);
            },
            criteria,
            mappings
        );
    }

    bindCta(results) {
        if (!results) results = wo$('#search-results-partial');
        WhistleOut.bindCta(results);
    }
}

// TODO: Extract a component for the queue
TabletsResultsAdaptor.coverageRequestsQueue = [];
